import styled from 'styled-components';
import { font2XL, fontM, fontXL } from 'styles/jakarta';
import { TABLET, DESKTOP, MAX_WIDTH } from './breakpoints';

export const PageWrapper = styled.div`
  background-color: ${({ theme }) => theme.background};
  min-height: 100vh;
`;

export const PageHeader = styled.h1`
  ${font2XL};
  font-weight: 600;
  color: ${({ theme }) => theme.content};
  margin-bottom: 16px;

  @media (min-width: ${TABLET}) {
    font-size: 44px;
  }
  @media (min-width: ${DESKTOP}) {
    font-size: 66px;
  }
`;

export const SecondaryHeader = styled.h2`
  ${fontM};
  color: ${({ theme }) => theme.subContent};
  width: 288px;
  display: flex;
  align-self: center;
  margin-bottom: -40px;

  @media (min-width: ${TABLET}) {
    margin-bottom: 16px;
  }

  @media (min-width: ${DESKTOP}) {
    width: auto;
    margin-top: 8px;
    margin-bottom: 32px;
  }
`;

export const LogoWrapper = styled.div`
  padding: 24px 0;
  display: flex;
  justify-content: center;

  @media (min-width: ${DESKTOP}) {
    max-width: ${MAX_WIDTH};
    justify-content: flex-start;
    margin: 0 auto;
  }
`;

export const MainTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  flex: 1;
  position: relative;
  overflow-x: clip;
  max-width: ${MAX_WIDTH};
  margin: 0 auto;

  @media (min-width: ${DESKTOP}) {
    flex-direction: row;
    padding-top: 20px;
    padding-bottom: 129.76px;
    justify-content: space-between;
  }
`;

export const Symbol = styled.span`
  ${fontM};
  color: ${({ theme }) => theme.content};

  @media (min-width: ${DESKTOP}) {
    margin-top: -8px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-self: center;

  @media (min-width: ${DESKTOP}) {
    align-self: flex-start;
  }
`;

export const ImageWrapper = styled.div`
  width: 339.82px;
  display: flex;
  align-self: center;
  position: relative;
  bottom: -72px;

  @media (min-width: ${DESKTOP}) {
    display: none;
  }
`;

export const AppStoreButtonWrapper = styled.div`
  padding: 16px;
  position: sticky;
  bottom: 0;

  @media (min-width: ${TABLET}) {
    display: none;
  }
`;

export const AppStoreButtonWrapperDesktop = styled.div`
  display: none;

  @media (min-width: ${TABLET}) {
    display: flex;
    width: 316.52px;
  }
`;

export const MainPageTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: ${DESKTOP}) {
    align-items: flex-start;
  }
`;

export const DesktopHeroImage = styled.img`
  display: none;

  @media (min-width: ${DESKTOP}) {
    display: block;
    width: 286px;
    height: 412.19px;
    position: absolute;
    right: 0;
    bottom: -91px;
  }
`;

export const ControllerImage = styled.img`
  display: none;

  @media (min-width: ${DESKTOP}) {
    display: block;
    position: absolute;
    width: 279.56px;
    height: 309.57px;
    top: 215.72px;
    left: -10px;
  }
`;

export const PartnersHeader = styled.h1`
  color: ${({ theme }) => theme.content};
  ${font2XL};
  font-weight: 600;
  margin-bottom: 16px;

  @media (min-width: ${DESKTOP}) {
    max-width: 358px;
    text-align: left;
    margin-bottom: 8px;
  }
`;

export const ButtonWrapper = styled.a`
  display: flex;
  background-color: ${({ theme }) => theme.success.background};
  border-radius: 4px;
  color: ${({ theme }) => theme.success.text};
  padding: 7px 16px;
  flex: 1;
  justify-content: center;
  align-items: center;
  margin-bottom: -40px;
  cursor: pointer;
  :active,
  :visited {
    color: ${({ theme }) => theme.success.text};
  }
  span {
    ${fontM};

    @media (min-width: ${DESKTOP}) {
      ${fontXL};
      margin-bottom: 0;
    }
  }

  @media (min-width: ${DESKTOP}) {
    padding: 9px 24px;
    border-radius: 8px;
  }
`;

export const PartnersHero = styled.img`
  display: flex;
  align-self: center;
  position: relative;
  bottom: -72px;
  width: 288px;

  @media (min-width: ${DESKTOP}) {
    width: 330px;
    position: absolute;
    right: 0;
    bottom: -65px;
  }
`;

export const ParntersSecondaryHeader = styled.h2`
  ${fontM};
  color: ${({ theme }) => theme.subContent};
  margin-bottom: 16px;

  @media (min-width: ${DESKTOP}) {
    margin-bottom: 32px;
  }
`;

export const PartnersMainPageTextWrapper = styled(MainPageTextWrapper)`
  padding: 16px 16px 0 16px;

  @media (min-width: ${DESKTOP}) {
    padding: 0;
  }
`;

export const PartnersControllerImage = styled.img`
  display: none;

  @media (min-width: ${DESKTOP}) {
    display: block;
    position: absolute;
    width: 203.82px;
    height: 232.57px;
    top: 250.72px;
    left: 24px;
  }
`;
